import axios from 'axios';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from "../../../../Models/Utilisateur";
import { useState } from "react";
import { Button, Form, Tabs, Space, Spin, Table } from 'antd';
import type { TabsProps } from 'antd';
import Demand from '../../../../Models/MMontantBloquer';
import { Box, Typography } from '@mui/material';
import SweetAlert from "sweetalert2";
import InputForm from "../../../InputT";
import SearchModal from "../../../SearchModal";
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import ParamsPicklist from "../../../../Types/ParamsPicklist"
import Tab1 from './Tab1';
import SearInputG from "../../../SearchInput"
import Data from '../../../../Data/Data.json'
import { Radio } from 'antd';


//pour le tableau
import DataType from "../../../../Functions/Traitement/DataPeriodMHCQ";
import { ColumnGroupType, ColumnsType } from 'antd/es/table';
import { Crypter } from "../../../../Functions/Security/Crypter";
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import RadioBox from "../../../Radiox";
import { Margin } from '@mui/icons-material';



const OppositionCheque = () => {
    // usestate pour remplir le tableau
    const [donnees, setData] = useState<DataType[]>([]);
    const [state, setstate] = useState(false)
    const [Lim, setlim] = useState('aba')

    const Getselectcli = (value: any) => {
        setlim(form.getFieldValue("NUMCLI"))
        form.setFieldValue("NBCHQR", 1);
        consultComptes()

    }
    //let searchCompte: ParamsPicklist = { CodeAgence: Lim, Table: "HCQ", Colonne1: "NUMCPT", Colonne2: "NUMDEMANDE", Colagence: 'NUMCPT', Choix: 22 }


    //let searchCompte: ParamsPicklist = { CodeAgence: Lim, Table: "HCQ", Colonne1: "NUMCPT", Colonne2: "NUMDEMANDE", Colagence: 'NUMCPT', Choix: 22 }

    //   let searchNumCompte: ParamsPicklist = { CodeAgence: user.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "AGCCPT",colfiltre:"TYPCPT",valfiltre:'I', Choix: 22 }

    //column du tableau 
    const columns: ColumnsType<DataType> = [

        {
            title: 'Numéro chèque',
            dataIndex: 'NUMCHQ',
        },
        {
            title: 'Type chèque',
            dataIndex: 'TYPCHQ',
        },
        {
            title: 'Status',
            dataIndex: 'CDETAT',
        },
        {
            title: 'Situation',
            dataIndex: 'STACHQ',
        },
        {
            title: 'Montant chèque',
            dataIndex: 'MTNCHQ',
        },
        {
            title: 'Agence',
            dataIndex: 'AGCCPT',
        }
    ];

    // USER SESSION
    const [form] = Form.useForm();
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [sbmit, setSbmit] = useState("")
    const [Impot, setImpot] = useState(false)

    const authHeader = useAuthHeader()

    let searchDmandCHQ: ParamsPicklist = { CodeAgence: Perss.codage, Table: "DEMANDECHQ", Colonne1: "NUMDEMANDE", Colonne2: "NOMCPT", Colagence: 'codeage', colfiltre: "CDETAT", valfiltre: '02', Choix: 22 }


    // Handle pour la selection des element dans le tableau
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    // function pour la selection du tab
    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed :) ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);
        //sessionStorage.setItem(Data.LocalVariable.FourthValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].REFMARQ))
        sessionStorage.clear();
        sessionStorage.setItem(Data.LocalVariable.FirstValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].NUMCHQ))
        sessionStorage.setItem(Data.LocalVariable.SecondValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].NUMDEMANDE))
        sessionStorage.setItem(Data.LocalVariable.ThirdValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].SERCHQ))
    };

    const rowSelection = {
        onChange: onSelectChange,
        selectedRowKeys,
    };

    const [checkboxValues, setCheckboxValues] = useState({
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
    });
    function handleCheckboxChange(events = require('events')) {
        const { name, checked } = events.target;
        setCheckboxValues({ ...checkboxValues, [name]: checked });
    }


    // usestate 
    function handleAnnul() {
        setSelectedRowKeys([]);
    }

    // Gestion des Items 
    const items: TabsProps['items'] = [
        {
            key: '2',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Opposition Chèque
                </span>
            ),
            children: <Tab1 />, //form={form}
        },
    ];

    // function Handle

    function HandleAnnul() {

        form.resetFields();
        setSelectedRowKeys([]);
        setImpot(false);
        setData([]);
    }

    function HandleOppose() {

        Consultableau();
        setSelectedRowKeys([]);
    }


    // CONSULT POUR RECUPERER LE COMPTE
    function consultComptes() {
        if (form.getFieldValue("NUMDEMANDE") == null) {
            SweetAlert.fire({ title: "Svp renseigner le numero de reference", icon: "warning" });
            //HandleAnnul();
        } else {

            // console.log('numero :' + form.getFieldValue("NUMDEMANDE"))
            // console.log('agence :' + Perss.codage)
            let data = Crypter.encrypt(form.getFieldValue("NUMDEMANDE"));
            let codeage = Crypter.encrypt(Perss.codage)
            //alert(form.getFieldValue("NUMDEMANDE"))
            if (data.length != 0) {
                setLoading(true)
                form.resetFields()
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadDemandCHQ,
                    headers: {
                        'CypherREFMARQ': data,
                        'CypherCodeage': codeage,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));

                            if (res.Result == null) {
                                SweetAlert.fire({ title: "Warning", text: 'la Référence appartient a une agence distante', icon: "warning" });
                                HandleAnnul()
                            } else {

                                let DemandCHQ = res.Result.Table[0];
                                if (res.StatutCode == 200) {
                                    form.setFieldsValue(DemandCHQ);
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }





    // function consult tableableau
    function Consultableau() {
        localStorage.clear()
        setSelectedRowKeys([]);

        if (form.getFieldValue("NUMCPT") == null) {
            SweetAlert.fire({ title: "Renseigner la Reference", text: "", icon: "warning" })
        } else {
            // if (form.getFieldValue("Type") == null) {
            //     SweetAlert.fire({ title: "Renseigner le type de chéquier a valider", text: "", icon: "warning" })
            // } else {
            let a;

            if (form.getFieldValue("NUMCPT") == null) {
                a = (Crypter.decrypt((sessionStorage.getItem(Data.LocalVariable.ThirdValueAuto) + '')) + "");
            } else {
                a = form.getFieldValue("NUMCPT");
            }

            let b = '1';
            let c = ("0");
            let d = Perss.codage;
            setImpot(true);


            setLoading(true)
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.AllreadHCQ,
                headers: {
                    'CypherNUMCPT': Crypter.encrypt(a),
                    'CypherETAT': Crypter.encrypt(b),
                    'CypherTYPE': Crypter.encrypt(c),
                    'Cyphercodeage': Crypter.encrypt(d),
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json',
                },
            };


            // MAPPING DANS LE TABLEAU
            let dat: DataType[] = [];
            axios.request(config)
                .then((response) => {
                    setLoading(false);

                    if (response.data) {
                        let datas = JSON.parse(JSON.stringify((response.data.Result)));
                        //sessionStorage.setItem(Data.LocalVariable.FourthValueAuto, Crypter.encrypt(datas[1].NUMDEMANDE))
                        //console.log('response.data stan ' + (datas[1].NUMDEMANDE));
                        datas.map((val: any, key: any) => {
                            dat.push({
                                key: key,
                                NUMCHQ: val.NUMCHQ,
                                SERCHQ: val.SERCHQ,
                                DATPAI: val.DATPAI,
                                MTNCHQ: val.MTNCHQ,
                                TYPCHQ: val.TYPCHQ,
                                NUMRAP: val.NUMRAP,
                                STACHQ: val.STACHQ,
                                DATSAI: val.DATSAI,
                                datcre: val.datcre,
                                AGCCPT: val.AGCCPT,
                                NUMCPT: val.NUMCPT,
                                UTILIS: val.UTILIS,
                                CDETAT: val.CDETAT,
                                UTIVAL: val.UTIVAL,
                                NUMDEMANDE: val.NUMDEMANDE,
                                DATVAL: undefined,
                                NBCHQS: undefined,
                                NBCHQR: undefined,
                                trie: undefined
                            })
                        })
                        setData((dat))
                    } else {
                        SweetAlert.fire({ title: "Error", text: "Aucun Element dans le tableau", icon: "warning" })
                    }
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false);
                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                });
            //}
        }

    }

    // function Onfinish
    const onFinish = (values: any) => {

        console.log('la valeur :' + selectedRowKeys.length)

        if (selectedRowKeys.length == 0) {
            SweetAlert.fire({ title: " selectionner le chèque a opposé", text: "", icon: "warning" })
        } else {


            let data1 = (((sessionStorage.getItem(Data.LocalVariable.FirstValueAuto) + '')) + "");
            let data2 = (((sessionStorage.getItem(Data.LocalVariable.SecondValueAuto) + '')) + "");
            let data3 = (((sessionStorage.getItem(Data.LocalVariable.ThirdValueAuto) + '')) + "");
            let data4 = Crypter.encrypt(Perss.coduti);
            let data5 = Crypter.encrypt(Perss.codage);
            let data6 = Crypter.encrypt('1');
            let data7 = Crypter.encrypt(form.getFieldValue("motif"))


            SweetAlert.fire({
                title: "Opposer le chéque",
                text: "Voulez-vous Opposer le chéque " + (Crypter.decrypt(data1)),
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: 'question'
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.LeverEOpositionHCQ,
                        headers: {
                            'CypherNUMCHQ': data1,
                            'CypherNUMDEMANDE': data2,
                            'CypherSERCHQ': data3,
                            'CypherUTIVAL': data4,
                            'CypherAGCCPT': data5,
                            'Cyphertrie': data6,
                            'Cyphermotif':data7,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);

                            if (response.data) {
                                // console.log(response.data)
                                const res = JSON.parse(Crypter.decrypt(response.data));

                                // console.log("Statut code"+res);
                                // console.log("Message :"+res.Message);
                                // console.log("Result :"+res.Result);
                                // let code = res.Result;

                                if (res.StatutCode == 200) {
                                    if (res.Message == "errorUser") {
                                        sessionStorage.clear();
                                        setIsSubmit(false);
                                        SweetAlert.fire({ title: res.Result, icon: "warning" });
                                        Consultableau();
                                    } else {
                                        sessionStorage.clear();
                                        setIsSubmit(false);
                                        SweetAlert.fire({ title: res.Result, text: 'Mise en Opposition Effectué avec succés', icon: "success" });
                                        Consultableau();
                                    }
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" });
                                }

                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                        });
                } else {
                    sessionStorage.clear();
                    setSelectedRowKeys([]);
                }
            })
        }


    }



    // control du forms 
    const onFinishFailed = (errorInfo: any) => {
        setLoading(true);
        setLoading(false);
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            SweetAlert.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };
    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> opposition de chèque : {window.location.pathname.toUpperCase()}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                <Form disabled={ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { Consultableau() }} type="ghost" block>
                                    Afficher
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { }} type="ghost" htmlType='submit' block  >
                                    Opposer
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { HandleAnnul() }} type="ghost" block  >
                                    Annuler
                                </Button>

                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                            <div className='tabItem' >
                                <div style={{ display: 'block flow' }}  >
                                    <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                                        <Box fontStyle="inherit" className='border-left '>
                                            <legend> Mise en place d'une opposition sur un chèque </legend>
                                              <Box className='border' style={{ display: 'flex' }} sx={{  mb: 2,marginTop: 1 }}>
                                               
                                                    <SearchModal Taille1={150}  Taille2={250}  disabled={false} Titre="" label="Réference" name="NUMDEMANDE" Parametre={searchDmandCHQ} ExecuteafterSelect1={Getselectcli}  form={form} />
                                                    <SearchModal Taille1={250}  Taille2={300}  disabled={true} Titre="" label="N° de compte" name="NUMCPT"  form={form} />
                                              </Box>
                                                
                                                 <Box  className='border' style={{ marginTop: -5  }} sx={{  mb: 2,marginTop: 1 }}>
                                                     <InputForm value={1} width={4} label="Motif de l'opposition" type="texte" name="motif" />
                                                 </Box>

                                                 <Box fontStyle="inherit" className='border'  sx={{  mb: 2,marginTop: 1 }}>
                                                  <Spin spinning={loading}>
                                                   <Table dataSource={donnees} rowSelection={{ ...rowSelection, type: "radio", getCheckboxProps: (reccord) => ({ disabled: false }) }} columns={columns} style={{ textAlign: "center", width: '100%' }} size='small' pagination={false} scroll={{ y: 400, x: 400 }} />
                                                 </Spin>
                                               </Box>               
                                        </Box>
                                        
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}


export default OppositionCheque;